function addAddOnProductAddToCartListener() {
    const add_on_buttons = document.querySelectorAll('.fs-add-to-cart-add-on-product-btn');
    add_on_buttons.forEach((btn) => {
        btn.addEventListener('click', async function () {
            const variantId = this.dataset.variantId;
            const quantity = 1;

            const spinner = this.querySelector('.loading__spinner');
            spinner?.classList.remove('hidden');

            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        items: [{ id: variantId, quantity: quantity }],
                        sections: ['cart-drawer', 'cart-icon-bubble'],
                        sections_url: window.location.pathname
                    })
                });

                if (!response.ok) throw new Error('Cart add failed');

                const cartData = await response.json();

                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    cartDrawer.classList.remove('is-empty');
                    cartDrawer.renderContents(cartData);
                    cartDrawer.open();
                }
            } catch (err) {
                console.error(err);
            } finally {
                spinner?.classList.add('hidden');
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', addAddOnProductAddToCartListener);